import { useMutation, useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { VEHICLE_USER } from "../../../common/query-keys";
import { CmpCarManagementInfoContent } from "../../../components/organisms/CmpPageContent/CmpCarManagementInfoContent";
import { VehicleInfoRegistrationType } from "../../../interface/transportation";
import { request } from "../../../lib/api";
import { UserVehicle } from "../../../types/driver.types";
import { MoreTemplates } from "../../../components/template/MoreTemplates";
import { useNavigate } from "react-router";

const CmpCarManagementInfoPage = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, watch, reset } =
    useForm<VehicleInfoRegistrationType>({
      defaultValues: {
        vehicleNumber: "",
        vehicleType: "차종",
        standard: "규격",
        chassis: "샤시",
        vehicleFeatures: [],
      },
    });

  const { isLoading } = useQuery({
    queryKey: [VEHICLE_USER],
    queryFn: async () => {
      const result = await request<UserVehicle>({
        method: "GET",
        url: VEHICLE_USER,
      });

      if (result) {
        reset(result);
      }

      return result;
    },
  });

  const onVehicleInfoChangePageMoveHanlder = () => {
    navigate("/carinfochange");
  };

  return (
    <MoreTemplates
      pageTitle="차량정보 변경"
      pageHeaderTitle="설정"
      background="white"
    >
      <CmpCarManagementInfoContent
        register={register}
        setValue={setValue}
        watch={watch}
        onVehicleInfoChangePageMoveHanlder={onVehicleInfoChangePageMoveHanlder}
      />
    </MoreTemplates>
  );
};

export default CmpCarManagementInfoPage;
